var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M18.95 2.22a.75.75 0 0 0 0 1.06l1.767 1.768a.75.75 0 0 0 1.061-1.06L20.01 2.22a.75.75 0 0 0-1.06 0m-14.963 0a.75.75 0 0 1 1.061 1.06L3.28 5.048a.75.75 0 0 1-1.06-1.06zM20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m1.5 0a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0m-4.793.14c0 2.16-1.01 3.64-2.8 3.64-1.78 0-2.8-1.48-2.8-3.64s1.02-3.64 2.8-3.64c1.79 0 2.8 1.48 2.8 3.64m-4.22 0c0 1.48.48 2.29 1.42 2.29s1.43-.81 1.43-2.29-.49-2.3-1.43-2.3-1.42.82-1.42 2.3M7 9.29l1.84-.65h1.2v7H8.66V10.1l-1.32.37z",
    clipRule: "evenodd"
  })));
};
export default SvgClock;